import React, { useState } from "react";

import SearchBox from "../../containerSmall/searchBox/searchBox.component";
import SearchSuggestionList from "../../containerSmall/searchSuggestionList/SearchSuggestionList.component";

const MapSuggestion = () => {
  const [inputValue, setInputValue] = useState("");
  const [listIsloading, setListIsloading] = useState(false);

  return (
    <div>
      <SearchBox
        setListIsloading={setListIsloading}
        setInputValue={setInputValue}
        inputValue={inputValue}
      />

      <SearchSuggestionList
        listIsloading={listIsloading}
        inputValue={inputValue}
        setInputValue={setInputValue}
      />
    </div>
  );
};

export default MapSuggestion;
